import { render, staticRenderFns } from "./GenresTreeSelectInput.vue?vue&type=template&id=324e323c&"
import script from "./GenresTreeSelectInput.vue?vue&type=script&lang=js&"
export * from "./GenresTreeSelectInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports